<template>
  <div id="app">
    <header>
      <div class="title">
        <router-link to="/">HABAKI</router-link>
      </div>
      <div id="navWrapper">
        <nav :class="navClass">
          <router-link to="/#about" @click.native="toggleMenu">About</router-link>
          <router-link to="/#character" @click.native="toggleMenu">Character</router-link>
          <router-link to="/guide" class="guideline_link" @click.native="toggleMenu">Guideline</router-link>
          <router-link to="/#contact" @click.native="toggleMenu">Contact</router-link>
        </nav>
        <menu-button ref="menuButton" @toggle="onMenuToggle"></menu-button>
      </div>
    </header>

    <router-view />
    <hr />
    <footer>
      ©2020 鈨組 All Rights Reserved
    </footer>
  </div>
</template>

<script>
import menuButton from '@/components/shared/menu_button.vue'
export default {
  components: {
    menuButton
  },
  data() {
    return {
      menuOpened: false
    }
  },
  computed: {
    navClass() {
      return this.menuOpened ? 'nav-opened' : ''
    }
  },
  methods: {
    onMenuToggle(value) {
      this.menuOpened = value
    },
    toggleMenu() {
      this.$refs.menuButton.onClick()
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap');
@import 'stylesheets/variables';

html,
body {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
}

#app {
  font-family: 'Noto Sans JP', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: $normal-bg;
  color: $text-white;
  font-weight: 900;
}

header {
  position: relative;
  z-index: 2;
  background-color: $white;
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  box-shadow: 0 4px 4px rgba($color: $black, $alpha: 0.25);
}

.title a {
  color: $normal-bg;
  font-size: 36px;
  text-decoration: none;
}

#navWrapper {
  display: flex;
  align-items: center;

  a {
    color: $normal-bg;
    font-size: 24px;
    text-decoration: none;
    margin-left: 16px;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

hr {
  margin: 8px 0 0 0;
}

footer {
  align-items: center;
  display: flex;
  font-size: 14px;
  text-align: center;
  margin: 4px 0 0 0;
  padding: 12px 0;
  justify-content: center;
  font-weight: 700;
}

@media screen and (max-width: 980px) {
  nav {
    display: none;
    transition: 0.3s;
  }

  .nav-opened {
    position: fixed;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    top: 0;
    left: 0;
    color: $text-white;
    align-items: center;
    justify-content: center;
    background-color: $normal-bg;
    box-sizing: border-box;
  }
  ::v-deep .menu-button-opened {
    position: fixed;
    top: 24px;
    right: 16px;
  }

  #navWrapper a {
    color: $text-white;
    display: block;
    border: 1px solid;
    border-right-width: 0;
    border-left-width: 0;
    min-width: 8em;
    text-align: center;
    padding: 8px;
    margin: 8px 0;

    &.router-link-exact-active:not(.guideline_link) {
      color: $text-white;
    }
  }
}
</style>
